import SpinningCube from './component/SpinningCube';
function App() {
  return <SpinningCube />;
}
export default App;
